<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row wrap>
    <v-flex xs12 sm6 md5 lg4 xl4>
      <v-card>
        <v-img :src="game.cover" :lazy-src="game.cover" />
      </v-card>
    </v-flex>
    <v-flex xs12 sm6 md7 lg4 xl4>
      <v-expansion-panel :expand="false">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Plateformes</div>
          </template>
          <v-card>
            <v-list>
              <template v-for="(platform, index) in game.platforms">
                <v-divider :key="'platform-' + index" v-if="index > 0"></v-divider>
                <v-list-tile :key="platform">
                  <v-list-tile-content>
                    <v-list-tile-title @click="$emit('go-to-platform', platform)">{{ platform }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-list>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>

    <v-flex v-if="screenshots().length" xs12 sm12 md5 lg4 xl4>
      <v-expansion-panel :expand="false">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Screenshots</div>
          </template>
          <v-card>
            <v-carousel v-if="screenshots().length" hide-delimiters>
              <v-carousel-item v-for="(screenshot, i) in screenshots()" :key="i" :src="screenshot"></v-carousel-item>
            </v-carousel>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>

    <v-flex xs12 sm12 md7 lg12 xl12>
      <v-expansion-panel :key="i" v-for="(test, i) in game.reviews" :expand="false">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>
              Test de {{ test.auteur }}
              <v-rating :value="test.note_tot / 2" color="primary accent-4" dense readonly half-increments size="18"></v-rating>
            </div>
          </template>
          <v-card>
            <v-card-text v-html="format(test.commentaire)"></v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-flex>

    <v-flex xs12 sm12 md12 lg12 xl12>
      <v-card>
        <v-card-title primary-title>
          <div>
            <h3 class="headline mb-0">Classements</h3>
          </div>
        </v-card-title>
        <v-expansion-panel>
          <v-expansion-panel-content :key="'ranking-' + index" v-for="(ranking, index) in game.rankings">
            <template v-slot:header>
              <div>{{ rankingName(ranking) }}</div>
            </template>
            <v-card>
              <Ranking :scores="ranking.scores"></Ranking>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Ranking from '@/components/molecules/Ranking';
import _ from 'lodash';

export default {
  props: ['game'],
  components: { Ranking },
  computed: {
    platform() {
      return this.$route.params.platform;
    },
  },
  data: () => ({
    show: false,
  }),
  methods: {
    rankingName(ranking) {
      const name = `${ranking.mode.name ? ranking.mode.name : ''} ${
        ranking.difficulty.name ? ranking.difficulty.name : ''
      }`.trim();
      if (name.length === 0) {
        return 'Général';
      }
      return name;
    },
    screenshots() {
      return _(this.game.reviews)
        .flatMap(test => [test.url_img1, test.url_img2, test.url_img3, test.url_img4, test.url_img5])
        .filter(x => !!x)
        .map(x => `http://shmup.com/images/thumbs/${x}`)
        .value();
    },
    format(value) {
      return value.replace(/\\/g, '').replace(/\n/g, '<br>');
    },
  },
};
</script>
